import { PROJECT_AUDIO_TYPES } from 'consts/audio'
import { sortArraysByKey } from 'store/features/projectData/utils'
import { TMultilineAudioItems } from 'store/types/audio'
import { ITtsItem, ITtsItemData, ITtsSpeaker } from 'types/text-to-speech'

export const filterTtsFromAudios = (
  multilineAudioItems: TMultilineAudioItems
) => multilineAudioItems.filter(item => item.type === PROJECT_AUDIO_TYPES.TTS)

export const getSortedTtsItemIdsFromAudios = (audios: TMultilineAudioItems) =>
  sortArraysByKey('projectStart', audios).map(audio => Number(audio.assetId))

export const reorderTtsItemsByIds = (
  items: ITtsItemData[],
  sortedIds: number[]
): ITtsItemData[] => {
  return items.sort((a, b) => {
    const aIndex = sortedIds.indexOf(a.id)
    const bIndex = sortedIds.indexOf(b.id)
    return aIndex - bIndex
  })
}

export const filterDeletedItems = (
  item: ITtsItemData,
  sortedIds: number[]
): ITtsItemData | null => {
  return sortedIds.includes(item.id) ? item : null
}

// to convert the response from ttsAudio to ttsItem ( ttsAudio has only data, not the states)
export const convertTtsAudioToTtsItem = (data: ITtsItemData): ITtsItem => ({
  data: { ...data },
  isGenerated: true,
  isLoading: false,
  isDraft: false
})

export const getFinalReorderedAndFilteredItems = (
  allItemsData: ITtsItemData[],
  sortedTtsAudiosIds: number[]
) => {
  return reorderTtsItemsByIds(allItemsData, sortedTtsAudiosIds)
    .map(item => filterDeletedItems(item, sortedTtsAudiosIds))
    .filter(item => item !== null)
    .map(convertTtsAudioToTtsItem)
}

export const checkIsPremiumVoice = (
  speakerId: number,
  speakers: ITtsSpeaker[]
): boolean =>
  speakers.find(speaker => speaker.id === speakerId)?.isPremium || false
